<template>
    <v-app>

        <Drawer current_item="menu_noti"></Drawer>

        <v-main class="ml-6 mr-6" >

          <v-card max-width="500" class="pa-6 mt-4">
            <div class="text-h6 mb-4" align="left"><b>{{ $t('admin_noti_station') }}</b></div>
            <FragmentSelectStation @onchange="onStationChange"></FragmentSelectStation>

            <div class="text-h6 mb-4" align="left"><b>{{ $t('admin_noti_datetime') }}</b></div>
            
            <v-menu
              v-model="date_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    :label="$t('date')"
                    prepend-icon="event"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="date_menu = false"></v-date-picker>
              </v-menu>

              <div align="center">
                <vue-clock-picker
                    mode="24" 
                    :defaultHour="0"
                    :defaultMinute="0"
                    :onTimeChange="onTimeChange"
                >
                </vue-clock-picker>
              </div>

            <v-btn class="mt-12" color="primary" @click="remindAppointment">{{ $t('admin_noti_submit') }}</v-btn>

          </v-card>

          <v-card max-width="500" class="pa-6 mt-4">
            <div class="text-h6 mb-4" align="left"><b>แจ้งเตือนให้กับเจ้าหน้าที่ทุกคนสำหรับ</b></div>
            <FragmentSelectStation @onchange="onStationChange_allstaff"></FragmentSelectStation>


            <v-btn class="mt-12" color="primary" @click="notAllStaff">{{ $t('admin_noti_submit') }}</v-btn>

          </v-card>


          
        </v-main>
    </v-app>
</template>

<style>
.time-picker-modal-container{
  width:inherit
}
.outside-click-container{
  left:77%
}
</style>

<script>
import Drawer from '@/components/Drawer.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import VueClockPicker from 'vue-clock-picker'

export default {
  components: {
    Drawer
    ,FragmentSelectStation
    ,VueClockPicker
  },
  data () {
    return {
        station : {}
        ,date_menu : false
        ,date: null
        ,time: "00:00"

        ,station_allstaff : {}
    }
  },
  mounted : function () {
    this.date = new Date()
    this.date.setHours(this.date.getHours()+7)
    this.date = this.date.toISOString().substr(0, 10)
    this.$store.getters.getStationList
    .then(result=>{
      this.select_station_items = result
    }).catch(error => {
      this.$router.push({name:'Error',params:error}) 
    })
  },
  methods : {
    remindAppointment(){
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.noti.noti_remind,{
            station_code : this.station.station_code
            ,datetime : this.date + ' ' + this.time
        },{ headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    },
    notAllStaff(){
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.noti.noti_allstaff,{
            station_code : this.station_allstaff.station_code
        },{ headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    },
    onStationChange(station){
      this.station = station
    },
    onStationChange_allstaff(station){
      this.station_allstaff = station
    },
    onTimeChange(time){
      let { hour, minute } = time
      hour = '00' + hour
      hour = hour.substring(hour.length-2,hour.length)
      minute = '00' + minute
      minute = minute.substring(minute.length-2,minute.length)
      this.time = hour + ':' + minute
    }
  }
}
</script>